import { Injectable } from "@angular/core";
import { HTTPService } from "app/shared/services/http.service";
import { AuthService } from "app/login/services/auth.service";
import { first } from "rxjs/operators";
import { SubscriptionService } from "./subscription.service";

@Injectable()
export class AnnouncementService {

    constructor(private dac$http:HTTPService, private authService:AuthService, private subscriptionService:SubscriptionService) {
    }

    public getAnnouncements() {
        let announcementRequest = this.dac$http.get("/announcements/");
        let loginStateRequest = this.authService.getLoginState().pipe(first()).toPromise();
        return Promise.all([announcementRequest, loginStateRequest]).then((results) => {
            let [resp, loginState] = results;
            let announcement = resp.json() as any;
            let announcementResults = [];
            if (announcement.length) {
                announcementResults = announcement.map(i => {
                    return {
                        id: i.id
                        ,content: i.content
                        ,link: i.link
                        ,linkTitle: i.linkTitle
                        ,linkType: 'external'
                        ,type: 'info'
                    };
                });
            }

            if (loginState && !loginState.user.hasActiveSubscription()) {
                announcementResults.push({
                    id: '0-expiredsubscription'
                    ,content: "Your current subscription has ended and some functionality has been disabled.  Avoid termination of services by activating your subscription!"
                    ,link: this.subscriptionService.getSubscriptionPageRoute()
                    ,linkTitle: 'Learn More'
                    ,linkType: 'internal'
                    ,type: 'warning'
                });
            }
            
            return announcementResults;
        });
    }

    public markAnnouncementRead(announcement:any) {
        if (announcement.id == '0-expiredsubscription') {
            return Promise.resolve(true); // mark it as read since it's internal
        }
        return this.dac$http.post("/announcements/" + announcement.id, {read: true})
        .then(() => {
            return true;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/services/announcement.service.ts